'use client';

import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation'; // 1. Added useRouter here

export default function DesktopHeader() {
  const pathname = usePathname();
  const router = useRouter(); // 2. Initialized router here

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Membership Plans', path: '/membershipPlans' },
    { name: 'Diet Plans', path: '/dietplans' },
    { name: 'Transformations', path: '/transformations' },
    
    { name: 'Blogs', path: '/blogs' },
    { name: 'Join Us', path: '/join' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <div className="hidden md:block w-full font-sans relative z-50">
      {/* Top Bar - Thinner */}
      <div className="bg-black text-white px-6 py-2 flex items-center justify-between h-[60px]">
        {/* Left */}
        <div className="flex items-center gap-3 z-10">
          <a href="/">
            <span className="uppercase tracking-wider text-xl font-bold bg-gradient-to-r from-[#faaf40] to-white bg-clip-text text-transparent animate-gradient">
              AURA WELLNESS CLUBS
            </span>
          </a>
        </div>

        {/* Right */}
        <div className="flex items-center gap-3 z-10">
          <div className="w-8 h-8 rounded-full bg-[#faaf40] flex items-center justify-center text-black font-bold text-sm select-none">
            A
          </div>

          {/* Sign In / Book Now Button */}
          <button
            onClick={() => router.push('/join')} // Linked this to your new Join page
            className="text-black text-xs px-4 py-1 rounded-full font-medium uppercase transition-transform duration-150 ease-in-out hover:opacity-90 active:scale-95"
            style={{
              background: 'linear-gradient(90deg, #faaf40 0%, #fcd77a 100%)',
            }}
          >
            Book Now
          </button>

          {/* Create / Explore Button */}
          <button
            onClick={() => router.push('/membershipPlans')}
            className="text-black text-xs px-5 py-1 rounded-full font-semibold uppercase transition-transform duration-150 ease-in-out hover:opacity-90 active:scale-95"
            style={{
              background: 'linear-gradient(90deg, #faaf40 0%, #fcd77a 100%)',
            }}
          >
            Explore Plans & Rewards
          </button>
        </div>
      </div>

      {/* Logo Overlay */}
      <div
        className="absolute w-[70px] h-[50px] top-[10px] left-1/2 transform -translate-x-1/2 z-20"
        style={{
          filter: 'drop-shadow(0 0 6px black) drop-shadow(0 0 12px #000000ff)',
        }}
      >
        <Image
          src="/logoWhite.png"
          alt="Aura Wellness Clubs Logo"
          width={60}
          height={60}
          className="object-contain spin-y"
          priority
          style={{
            filter: 'drop-shadow(0 0 6px black) drop-shadow(0 0 12px #000000ff)',
          }}
        />
      </div>

      {/* Bottom Nav Bar - Thicker */}
      <div className="bg-gradient-to-r from-[#1f1f1f] via-[#2c2c2c] to-[#3a2f21] border-t border-[#faaf40] pt-8 pb-5">
        <nav className="flex justify-center gap-6 text-sm tracking-wide">
          {navLinks.map(({ name, path }) => {
            const isActive = pathname === path;

            return (
              <a
                key={name}
                href={path}
                className={`relative transition-all duration-200 ease-in-out
                  ${isActive
                    ? 'text-white font-semibold underline decoration-[#faaf40] decoration-2 underline-offset-4'
                    : 'text-[#c0c0c0] hover:text-white hover:underline hover:decoration-[#faaf40] hover:decoration-2 hover:underline-offset-4'
                  }
                  active:text-[#faaf40] active:scale-95 active:underline active:decoration-[#faaf40] active:decoration-4 active:underline-offset-2
                `}
              >
                {name}
              </a>
            );
          })}
        </nav>
      </div>
    </div>
  );
}